class PiFetchNavigation extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.pageHandle = "mega-menu";
    this.sectionID = this.dataset.sectionId;
    this.url = `pages/${this.pageHandle}?section_id=${this.sectionID}`;
    this.MegaMenusClicked = false;
    this.childNavsClicked = false;
    this.handleMegaMenuClick = this.handleMegaMenuClick.bind(this);
    this.handleChildNavClick = this.handleChildNavClick.bind(this);
    this.initEventListeners();

    if (!this.dataset.preventCache) {
      this.handler();
      // on resize
      window.addEventListener("resize", () => {
        this.handler();
      });
    }
  }

  handler() {
    if (window.innerWidth > 1150) {
      if (!this.loaded) {
        const expiry = localStorage.getItem("megaMenuDataExpiry");
        const data = localStorage.getItem("megaMenuData");
        if (expiry && data && Number(expiry) > Date.now()) {
          this.loaded = true;
          console.log("data from local storage");
          this.render(data);
        } else {
          this.fetchNavigation();
        }
      }
    }
  }

  fetchNavigation() {
    this.loaded = true;
    fetch(this.url)
      .then((response) => response.text())
      .then((data) => {
        this.render(data);
        localStorage.setItem("megaMenuData", data);
        localStorage.setItem("megaMenuDataExpiry", Date.now() + 600000);
      });
  }

  render(data) {
    const html = new DOMParser().parseFromString(data, "text/html");
    const clickedMenuEl = this.querySelector(
      ".is-focused-click[data-main-nav-link]"
    );
    if (clickedMenuEl) {
      const clickedMenuID = clickedMenuEl.dataset.mainNavLink;
      const clickedMenuEl_new = html.querySelector(
        `[data-main-nav-link="${clickedMenuID}"]`
      );
      clickedMenuEl_new.classList.add("is-focused-click");
    }
    this.innerHTML = html.querySelector("pi-fetch-navigation").innerHTML;
    console.log("Mega Menu Rendered");
    this.removeEventListeners();
    this.initEventListeners();
    document.dispatchEvent(new CustomEvent("menu:loaded"));
  }

  initEventListeners() {
    this.MegaMenus = this.querySelectorAll(".site-nav__link--has-dropdown");
    this.MegaMenuParents = this.querySelectorAll(".site-nav--has-dropdown");
    this.childNavs = this.querySelectorAll(
      ".site-nav__item .subcategory-child"
    );

    this.MegaMenus.forEach((el) => {
      el.addEventListener("click", this.handleMegaMenuClick);
      el.addEventListener("touchstart", this.handleMegaMenuClick);
    });
    this.childNavs.forEach((el) => {
      el.addEventListener("click", this.handleChildNavClick);
      el.addEventListener("touchstart", this.handleChildNavClick);
    });
  }

  removeEventListeners() {
    this.MegaMenus?.forEach((el) => {
      el.removeEventListener("click", this.handleMegaMenuClick);
      el.removeEventListener("touchstart", this.handleMegaMenuClick);
    });
    this.childNavs?.forEach((el) => {
      el.removeEventListener("click", this.handleChildNavClick);
      el.removeEventListener("touchstart", this.handleChildNavClick);
    });
  }

  visibility(el, state) {
    if (!el) return;

    if (state) {
      el.style.display = "block";
    } else {
      el.style.display = "none";
    }
  }

  handleMegaMenuClick(event) {
    event.preventDefault();
    if (this.MegaMenusClicked) return false;
    this.MegaMenusClicked = true;
    setTimeout(() => (this.MegaMenusClicked = false), 100);
    const currentTarget = event.currentTarget;
    const clickedMenuParent = currentTarget.parentElement;
    this.MegaMenuParents.forEach((el) => {
      if (el !== clickedMenuParent) {
        el.classList.remove("is-focused-click");
        el.querySelectorAll(".desktop-subcollection-drop").forEach((el) => {
          this.visibility(el, false);
        });
        this.visibility(el.querySelector(".main-child-menu"), true);
      } else {
        clickedMenuParent.classList.toggle("is-focused-click");
        if (
          this.querySelectorAll(".bike-menu-link.is-focused-click").length > 0
        ) {
          document.body.classList.add("menu-open-body");
        } else {
          document.body.classList.remove("menu-open-body");
        }
        // W
      }
    });
    const els = Array.from(
      currentTarget.parentElement.querySelectorAll(".subcategory-child")
    );
    if (els.length > 0 && window.getComputedStyle(els[0]).display !== "none") {
      els[0].click();
    }
  }

  handleChildNavClick(event) {
    event.preventDefault();
    if (this.childNavsClicked) return false;
    this.childNavsClicked = true;
    setTimeout(() => (this.childNavsClicked = false), 100);
    const currentTarget = event.currentTarget;
    if (currentTarget.classList.contains("subcollection-menu-item")) {
      // SideBar Menu
      this.visibility(currentTarget.closest(".grid__item"), false);
    } else if (currentTarget.classList.contains("subcollection-back-btn")) {
      this.visibility(
        currentTarget.closest(".desktop-subcollection-drop"),
        false
      );
      this.visibility(
        this.querySelector(`#${currentTarget.dataset.mainId} .main-child-menu`),
        true
      );
      let el = this.querySelector(
        `#${currentTarget.dataset.mainId} .main-child-menu .menu-category-list a:first-child`
      );
      if (el) {
        setTimeout(() => {
          el.click();
        }, 100);
      }
      return;
    }
    this.querySelectorAll(
      `#${currentTarget.dataset.mainId} .subcategory-child`
    ).forEach((el) => {
      el.classList.remove("active-subcategory-child");
    });
    this.querySelectorAll(
      `#${currentTarget.dataset.mainId} .desktop-grandchilds`
    ).forEach((el) => {
      this.visibility(el, false);
    });
    currentTarget.classList.add("active-subcategory-child");
    this.visibility(
      this.querySelector(`#${currentTarget.dataset.targetMenu}`),
      true
    );
    if (currentTarget.classList.contains("subcollection-menu-item")) {
      let el = this.querySelector(
        `#${currentTarget.dataset.targetMenu} .menu-category-list a:nth-child(2)`
      );

      if (el) {
        setTimeout(() => {
          this.childNavsClicked = false;
          el.click();
        }, 150);
      }

      return;
    }
    if (window.AOS) {
      AOS.refreshHard();
    }
  }
}

customElements.define("pi-fetch-navigation", PiFetchNavigation);

class PiFetchMenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
    this.pageHandle = "mega-menu";
    this.sectionID = this.dataset.sectionId;
    this.url = `pages/${this.pageHandle}?section_id=${this.sectionID}`;
    this.handlerSubMenusClick = this.handlerSubMenusClick.bind(this);
    this.handleButtonsClick = this.handleButtonsClick.bind(this);
    this.initEventListeners();
    if (!this.dataset.preventCache) {
      this.handler();
      window.addEventListener("resize", () => {
        this.handler();
      });
    }
  }
  handler() {
    if (window.innerWidth <= 1150) {
      if (!this.loaded) {
        const expiry = localStorage.getItem("megaMenuDataDrawerExpiry");
        const data = localStorage.getItem("megaMenuDataDrawer");
        if (expiry && data && Number(expiry) > Date.now()) {
          this.loaded = true;
          this.render(data);
        } else {
          this.fetchNavigation();
        }
      }
    }
  }
  fetchNavigation() {
    this.loaded = true;
    fetch(this.url)
      .then((response) => response.text())
      .then((data) => {
        localStorage.setItem("megaMenuDataDrawer", data);
        localStorage.setItem("megaMenuDataDrawerExpiry", Date.now() + 600000);
        this.render(data);
      });
  }

  render(data) {
    const html = new DOMParser().parseFromString(data, "text/html");
    this.innerHTML = html.querySelector("pi-fetch-menu-drawer").innerHTML;
    console.log("Drawer Rendered");
    this.removeEventListeners();
    this.initEventListeners();
  }
  visibility(el, state) {
    if (!el) return;

    if (state) {
      el.style.display = "block";
    } else {
      el.style.display = "none";
    }
  }

  initEventListeners() {
    this.SubMenus = this.querySelectorAll(".data-sublink-trigger");
    this.Buttons = this.querySelectorAll(".js-drawer-close,.back-btn");
    this.SubMenus.forEach((el) => {
      el.addEventListener("click", this.handlerSubMenusClick);
    });
    this.Buttons.forEach((el) => {
      el.addEventListener("click", this.handleButtonsClick);
    });
  }

  removeEventListeners() {
    this.SubMenus?.forEach((el) => {
      el.removeEventListener("click", this.handlerSubMenusClick);
    });
    this.Buttons?.forEach((el) => {
      el.removeEventListener("click", this.handleButtonsClick);
    });
  }

  handlerSubMenusClick(event) {
    event.preventDefault();
    const currentTarget = event.currentTarget;
    this.querySelectorAll(".mobile-nav__has-sublist").forEach((el) => {
      el.classList.add("hide");
    });
    this.nextElementSibling.classList.add("hide");
    currentTarget.closest(".mobile-nav__item")?.classList.add("active-subnav");
    this.querySelectorAll(".signin-link,.menu-gift-card").forEach((el) => {
      el.classList.add("hide");
    });
    this.querySelectorAll(".back-btn").forEach((el) => {
      this.visibility(el, true);
    });
  }
  handleButtonsClick(event) {
    event.preventDefault();

    this.querySelectorAll(".mobile-nav__item").forEach((el) => {
      el.classList.remove("active-subnav");
    });
    this.querySelectorAll(".mobile-nav__has-sublist").forEach((el) => {
      el.classList.remove("hide");
    });
    this.nextElementSibling.classList.remove("hide");

    this.querySelectorAll(".signin-link,.menu-gift-card").forEach((el) => {
      el.style.display = "inline-flex";
    });
    this.querySelectorAll(".back-btn").forEach((el) => {
      this.visibility(el, false);
    });
  }
}

customElements.define("pi-fetch-menu-drawer", PiFetchMenuDrawer);
